export const HEREWEARE_INSTALL_URL = "https://link.hereweare.io/install";
export const HEREWEARE_APP_STORE_URL = "https://apps.apple.com/us/app/id1491869024?l=en";
export const HEREWEARE_PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.hsoft.hwa&hl=en";
export const HEREWEARE_QR_PATH = "/install";

const BRANCH_ATTEMPT_KEY = "hereweare:install:branch-attempt";
const BRANCH_RETRY_WINDOW_MS = 60_000;

type MobileInstallPlatform = "ios" | "android" | "other";

export function getInstallStoreUrls() {
  const language = typeof navigator === "undefined" ? "" : navigator.language;
  // 브라우저 기본 언어가 한국어인 경우만 한국어 스토어 사용함
  const isKorean = /^ko(?:-|$)/i.test(language || "");

  return {
    appStoreUrl: isKorean ? "https://apps.apple.com/kr/app/id1491869024?l=ko" : HEREWEARE_APP_STORE_URL,
    playStoreUrl: isKorean ? "https://play.google.com/store/apps/details?id=com.hsoft.hwa&hl=ko" : HEREWEARE_PLAY_STORE_URL,
  };
}

export function getMobileInstallPlatform(): MobileInstallPlatform | null {
  if (typeof navigator === "undefined") return null;

  const userAgent = navigator.userAgent || "";
  const navigatorWithData = navigator as Navigator & {
    userAgentData?: { mobile?: boolean };
  };

  if (/Android/i.test(userAgent)) return "android";

  const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

  if (/iPhone|iPad|iPod/i.test(userAgent) || isIPadOS) return "ios";

  const hasMobileUserAgent = /webOS|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  if (hasMobileUserAgent || navigatorWithData.userAgentData?.mobile) return "other";

  return null;
}

export function isMobileInstallDevice() {
  return getMobileInstallPlatform() !== null;
}

export function getMobileInstallUrl() {
  return getInstallRedirectUrl();
}

export function getInstallRedirectUrl() {
  const platform = getMobileInstallPlatform();

  // iOS·Android는 Branch의 설치 여부에 따른 앱 열기·스토어 fallback 유지함
  if (platform === "ios" || platform === "android") return HEREWEARE_INSTALL_URL;

  return getInstallStoreUrl();
}

export function getInstallStoreUrl() {
  const platform = getMobileInstallPlatform();
  const { appStoreUrl, playStoreUrl } = getInstallStoreUrls();

  if (platform === "ios") return appStoreUrl;
  if (platform === "android") return playStoreUrl;

  const isMac = typeof navigator !== "undefined" && /Mac/i.test(navigator.platform || navigator.userAgent);

  // Branch와 /install 간 순환 방지를 위해 PC·미확인 기기도 스토어로 직접 이동함
  return isMac ? appStoreUrl : playStoreUrl;
}

export function prepareInstallRedirectUrl() {
  const installUrl = getInstallRedirectUrl();
  if (installUrl !== HEREWEARE_INSTALL_URL) return installUrl;

  try {
    const now = Date.now();
    const lastAttempt = window.sessionStorage.getItem(BRANCH_ATTEMPT_KEY);

    // 동일 탭에서 1분 내 복귀하거나 시계가 과거로 변경된 경우 Branch 재진입 차단함
    if (lastAttempt !== null && now - Number(lastAttempt) < BRANCH_RETRY_WINDOW_MS) {
      return getInstallStoreUrl();
    }

    window.sessionStorage.setItem(BRANCH_ATTEMPT_KEY, String(now));
    return installUrl;
  } catch {
    // 저장소 접근 차단으로 재진입 추적이 불가능한 경우 스토어로 직접 이동함
    return getInstallStoreUrl();
  }
}
